import type { BreadcrumbItem } from "./Breadcrumb"
import type { FunctionComponent } from "react"

import Head from "next/head"
import { useContext } from "react"

import { ServerContext } from "@/modules/server/context"

type BreadcrumbItemProps = {
  data: BreadcrumbItem[]
}

export const StructuredData: FunctionComponent<BreadcrumbItemProps> = ({ data }) => {
  const { baseUrl } = useContext(ServerContext) || { baseUrl: "" }
  const itemListElement = data.map((item, index) => ({
    "@type": "ListItem",
    name: item.title,
    position: index + 1,
    ...(item.href && { item: `${baseUrl}${item.href}` }),
  }))

  return (
    <Head>
      <script
        key="structured-data"
        type="application/ld+json"
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: itemListElement.filter(Boolean),
          }),
        }}
      />
    </Head>
  )
}
